import { Scene } from "phaser";

import {EventBus} from "../../main";

import preloaderStart from "../start/preloader";
import preloaderHallway from "../hallway/preloader";
import preloaderGameOver from "../gameOver/preloader";
import preloaderWin from "../win/preloader";
import preloaderCredits from "../credits/preloader";
import preloaderPause from "../pause/preloader";
import preloaderHelp from "../help/preloader";
import preloaderAbout from "../about/preloader";
import preloaderSettings from "../settings/preloader";
import preloaderGame1 from "../game1/preloader";
import preloaderGame2 from "../game2/preloader";
import preloaderGame3 from "../game3/preloader";
import preloaderGame4 from "../game4/preloader";
import preloaderGame5 from "../game5/preloader";
import preloaderGame6 from "../game6/preloader";
import preloaderGame7 from "../game7/preloader";
import preloaderGame8 from "../game8/preloader";
import preloaderGame9 from "../game9/preloader";
import preloaderGame10 from "../game10/preloader";
import preloaderGame11 from "../game11/preloader";
import preloaderGame12 from "../game12/preloader";
import preloaderGame13 from "../game13/preloader";
import preloaderGame14 from "../game14/preloader";
import DialogModalPlugin from "../../phaser/components/dialogPlugin"


export default class Preloader extends Scene {

    constructor()
	{
		super('preloader')
	}

    preload()
	{
        let file = 'thick_8x8'; // Nombre base de tu fuente
        this.load.bitmapFont('pixelfont', 'fonts/' + file + '.png', 'fonts/' + file + '.xml');
        preloaderStart(this);
        preloaderHallway(this);
        preloaderGameOver(this);
        preloaderWin(this);
        preloaderCredits(this);
        preloaderPause(this);
        preloaderHelp(this);
        preloaderAbout(this);
        preloaderSettings(this);
        preloadGeneral(this);
        preloaderGame1(this);
        preloaderGame2(this);
        preloaderGame3(this);
        preloaderGame4(this);
        preloaderGame5(this);
        preloaderGame6(this);
        preloaderGame7(this);
        preloaderGame8(this);
        preloaderGame9(this);
        preloaderGame10(this);
        preloaderGame11(this);
        preloaderGame12(this);
		preloaderGame13(this);
		preloaderGame14(this);

        this.load.once('complete', () => {
            EventBus.$emit('loading');
        }, this);
	}
	
	create()
	{
        this.plugins.install('dialogModal', DialogModalPlugin, true);
		
		this.scene.start('Start')
	}
}

function preloadGeneral(scene) {
    
    scene.load.spritesheet('fullscreen', 'img/generalSprites/fullscreenred.png', { frameWidth: 32, frameHeight: 32 });
    scene.load.spritesheet('pie', `/img/generalSprites/pie.png`, { frameWidth: 23.1, frameHeight: 21 });
    scene.load.spritesheet('cherry', `/img/generalSprites/cherry.png`, { frameWidth: 23.1, frameHeight: 21 });
    scene.load.spritesheet('perrito', `/img/generalSprites/perrito.png`, { frameWidth: 23.1, frameHeight: 21 });
    scene.load.spritesheet('gatito', `/img/generalSprites/gatito.png`, { frameWidth: 21, frameHeight: 21 });
    scene.load.spritesheet('plant', `/img/generalSprites/plant.png`, { frameWidth: 16, frameHeight: 16 });
    scene.load.spritesheet(`somnia`, 
        `/img/generalSprites/somnia.png`,
        { frameWidth: 25, frameHeight: 37}
);
    scene.load.image('settings', 'img/generalSprites/setings.png'); //TODO CORREGIR IMAGEN
    scene.load.image('pause', 'img/generalSprites/setings.png');
    scene.load.image('help', 'img/generalSprites/help-yellow.png');
    scene.load.image('heartRed', `/img/generalSprites/redHeart.png`);
    scene.load.image('heartBlack', `/img/generalSprites/blackHeart.png`);
    scene.load.image('lightstick', `/img/generalSprites/lightstick.png`);
    scene.load.image('backgroundPause', `/img/table.png`);
    scene.load.image('dialog-test', `/img/generalSprites/Dislogos.png`);
    scene.load.image('note-test', `/img/generalSprites/note.png`);
    scene.load.image(`interact-dialog`, `/img/generalSprites/GUI.png`);
	scene.load.image('buttonPlayInit', '/img/generalSprites/play.png');
	scene.load.image('backgroundSettings', '/img/background-settings.png');


    scene.load.spritesheet(`jiu-hallway`, 
		`/img/hallway/jiu.png`,
		{ frameWidth: 27, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-hallway`, 
		`/img/hallway/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-hallway`, 
		`/img/hallway/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-hallway`, 
		`/img/hallway/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-hallway`, 
		`/img/hallway/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-hallway`, 
		`/img/hallway/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-hallway`, 
		`/img/hallway/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
}